<template>
  <v-app>
    <v-main>
      <v-container class="pa-0 fill-height" fluid>
        <v-row class="fill-height ma-0">
          <v-col
            class="imredd-bg pos-relative  px-15"
            cols="12"
            md="6"
            sm="12"
            lg="4"
            xl="4"
          >
            <v-row class="fill-height px-10" align="center" justify="center">
              <v-col>
                <a :href="app.url" target="_blank"
                  ><img src="@/assets/logo_black.png" height="70px"
                /></a>

                <div class="h4 font-weight-light my-5">
                  <b>
                    Welcome !
                  </b>
                  <div class="mt-4">
                    Type your new password !
                  </div>
                </div>
                <v-text-field
                  label="Password"
                  type="password"
                  v-model="$v.resetForm.password1.$model"
                  :error-messages="errors.password1"
                  required
                />
                <v-text-field
                  class="d-block"
                  type="password"
                  v-model="$v.resetForm.password2.$model"
                  label="Repeat password"
                  :error-messages="errors.password2"
                  @keyup.enter="submit"
                  required
                />
                <div class="d-flex justify-center">
                  <v-btn
                    block
                    style="width:50%"
                    large
                    @click="submit"
                    @keyup.enter="submit"
                    class="mb-3 mt-5 d-block"
                    :disabled="$v.resetForm.$invalid | loaderSaveButton"
                    :loading="loaderSaveButton"
                    color="primary"
                    >Save</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="bg-cover fill-height hidden-xs-only hidden-sm-only md-6 lg-8 xl-8"
          />
        </v-row>
      </v-container>
    </v-main>
  </v-app>

  <!-- </v-app> -->
</template>

<script>
import { AccountService } from "@/services"
import { validationMixin } from "vuelidate"
import {
  required,
  url,
  numeric,
  alpha,
  sameAs,
  minLength
} from "vuelidate/lib/validators"
export default {
  name: "ResetPassword",
  mixins: [validationMixin],
  validations: {
    resetForm: {
      password1: {
        required,
        minLength: minLength(8)
      },
      password2: {
        required,
        sameAsP1: sameAs(function() {
          return this.resetForm.password1
        }),
        minLength: minLength(8)
      }
    }
  },
  data: function() {
    return {
      app: {
        name: "Perfumist",
        url: "https://perfumist.com"
      },
      resetForm: {
        password1: "",
        password2: ""
      },
      loaderSaveButton: false
    }
  },
  mounted: function() {
    this.clear()
  },
  computed: {
    errors() {
      const errors = {
        password1: [],
        password2: []
      }

      this.$v.resetForm.password1.$dirty &&
        !this.$v.resetForm.password1.required &&
        errors.password1.push("Password is required")

      this.$v.resetForm.password2.$dirty &&
        !this.$v.resetForm.password2.required &&
        errors.password2.push("Repeat password is required")

      this.$v.resetForm.password1.$dirty &&
        !this.$v.resetForm.password1.minLength &&
        errors.password1.push("Password must be longer than 8 characters")
      this.$v.resetForm.password2.$dirty &&
        !this.$v.resetForm.password2.minLength &&
        errors.password2.push(
          "Repeat password must be longer than 8 characters"
        )

      this.$v.resetForm.password2.$dirty &&
        !this.$v.resetForm.password2.sameAsP1 &&
        errors.password2.push("Password and repeat password are not the same")

      return errors
    }
  },
  methods: {
    submit() {
      if (!this.$v.resetForm.$invalid) {
        this.loaderSaveButton = true
        AccountService.sendNewPassword(
          this,
          this.resetForm.password1,
          this.resetForm.password2,
          this.$route.params.uid,
          this.$route.params.key
        )
          .then(r => {
            this.loaderSaveButton = false
          })
          .catch(error => {
            this.loaderSaveButton = false
          })
      }
    },
    clear() {
      this.$v.resetForm.$reset()
    }
  }
}
</script>
<style>
.imredd-bg {
  background-color: white;
}
.pos-relative {
  position: relative;
}
.bg-cover {
  background-color: #ff505c;
  background-size: cover;
  background-position: 50% 50%;
  background-image: url(../../assets/signin_cover.png);
}
.powered_by {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 15px;
}
</style>
